var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        error: _vm.error,
      },
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v("Варианты ответа")]),
      _c(
        "transition-group",
        { attrs: { name: "slide", tag: "div" } },
        _vm._l(_vm.value, function (variant) {
          return _c(
            "div",
            { key: variant.unique, staticClass: "variant" },
            [
              _c("c-input", {
                staticClass: "variant__field",
                attrs: {
                  "data-variant": variant.unique,
                  "max-length": 255,
                  clearable: true,
                  required: _vm.error,
                  "required-message": _vm.error,
                  placeholder: "Введите текст ответа",
                },
                on: { enter: _vm.onEnter },
                model: {
                  value: variant.text,
                  callback: function ($$v) {
                    _vm.$set(variant, "text", $$v)
                  },
                  expression: "variant.text",
                },
              }),
              _vm.value.length > 1
                ? _c("c-button", {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.hover.blur.top",
                        value: "Удалить",
                        expression: "'Удалить'",
                        modifiers: { hover: true, blur: true, top: true },
                      },
                    ],
                    staticClass: "variant__remove",
                    attrs: {
                      size: "iconic",
                      icon: { icon: "trash", color: "secondary" },
                    },
                    on: {
                      click: function ($event) {
                        return _vm.remove(variant)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _c("c-button", {
        staticClass: "add-variant",
        attrs: {
          size: "small",
          icon: { icon: "plus", color: "primary" },
          label: "Добавить вариант",
          disabled: _vm.disableAddButton,
        },
        on: { click: _vm.add },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }